var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseChildCollapseIconInModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5948 2.92439L9.48727 10.0914C9.34289 10.237 9.19002 10.3415 9.02865 10.4049C8.86731 10.4683 8.69517 10.5 8.51224 10.5C8.32933 10.5 8.1572 10.4683 7.99583 10.4049C7.83449 10.3415 7.68163 10.237 7.53725 10.0914L0.405166 2.89967C0.135055 2.62727 -3.58633e-07 2.29543 -3.75737e-07 1.90413C-3.92841e-07 1.51284 0.135055 1.18099 0.405166 0.908596C0.675301 0.6362 1.00848 0.504127 1.40472 0.512381C1.80093 0.520611 2.1341 0.660926 2.40423 0.933322L8.51224 7.09245L14.6448 0.908595C14.9149 0.636199 15.2399 0.499999 15.6198 0.499999C15.9997 0.499999 16.3247 0.636199 16.5948 0.908595C16.8649 1.18099 17 1.51695 17 1.91648C17 2.31602 16.8649 2.652 16.5948 2.92439Z",
    fill: "#4A4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChildCollapseIconInModal);
export default __webpack_public_path__ + "static/media/closeChildCollapseIconInModal.b3366f94.svg";
export { ForwardRef as ReactComponent };